
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import SelectionView from '../../../../../components/selectionView/SelectionView.js'

var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var storefrontUtility = require('../../../../../utils/domain/storefrontUtility');
var constants = require('../../../../../utils/domain/constants.js');
var stringUtil = require('../../../../../utils/string/stringUtil');
var translator = require('../../../../../utils/translator/translator.js');
var saleContextUtil = require('../../../utils/saleContextUtil.js');

class MenuToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);
        this.renderMenuSelectionDialogue = this.renderMenuSelectionDialogue.bind(this);

        this.state = {};
        this.state.showMenuSelectionDialogue = false;
    }

    render()
    {
        let saleContext = this.props.saleContext;
        
        let canChangeMenu =  saleCommonUtility.canChangeMenu(saleContext);
        return (<Fragment>
                    <div style={{textAlign:'center', opacity:canChangeMenu ? 1 : 0.5, color: "#787878"}}
                             onClick={(event) =>
                             {
                                event.stopPropagation();

                                if (!canChangeMenu)
                                    return; 

                                this.state.showMenuSelectionDialogue = true;
                                this.setState({})
                             }}>
                            <UtensilsIcon size="3vw"/>
                    </div>
                    {this.renderMenuSelectionDialogue()}

                </Fragment>)
    }

    renderMenuSelectionDialogue()
    {
        let saleContext = this.props.saleContext
        if (!this.state.showMenuSelectionDialogue)
            return null;

        let selections = [];
        let storefronts = storefrontUtility.getPOSStorefronts();
        storefronts.forEach(storefront =>
        {
            let selection = {};
            selection.caption = storefront.name
            selection.id = storefront.id;
            selection.isSelected = saleContext.selectedStorefrontId == storefront.id;
            selections.push(selection);
        })

        return <SelectionView selections={selections} caption={translator.getLabel("storefront_options")}
                onClose={()=>
                {
                    this.state.showMenuSelectionDialogue = false;
                    this.setState({});
                }}
                onSelection={(selection)=>
                {
                    this.state.showMenuSelectionDialogue = false;
                    this.setState({});

                    saleContextUtil.changeSaleContextMenu(selection.id);
                }}/>
        
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(MenuToolbarButton)

const UtensilsIcon = ({size})=>{
    return (
        <svg width={size} height={size} version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" >
            <path fill='none' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' strokeMiterlimit={10} d="M8,9h15c0.6,0,1,0.4,1,1v18c0,0.6-0.4,1-1,1H9c-0.6,0-1-0.4-1-1V9l11.6-5.3C20.2,3.3,21,3.8,21,4.6V9"></path>
            <path fill='none' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' strokeMiterlimit={10} d="M17.1,29l-0.4-3.3c-0.1-1.3,0.3-2.6,1.2-3.5c0.7-0.7,1.1-2,1.1-3.7V13"></path>
            <path fill='none' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' strokeMiterlimit={10} d="M13,13v5.5c0,1.7,0.4,2.9,1.1,3.7c0.9,1,1.3,2.2,1.2,3.5L14.9,29"></path>
            <line fill='none' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' strokeMiterlimit={10} x1="16" y1="19" x2="16" y2="13"></line>
        </svg>
    )
}